module.exports = __webpack_public_path__ + "img/Sympathy.2476f927.png";